<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.REQUEST_MANUAL_PAYMENT"
    :handler="
      () => {
        currentStep = 1;
        modalRef.show();
      }
    "
  />

  <DialogComponent
    ref="modalRef"
    type="modal"
    @closed="
      ({ source }) => {
        source !== 'filledButton' &&
          $bus.emit($constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED, {
            messageTitle: 'Transaction annulée',
            message: 'vous avez annulé la transaction'
          });
      }
    "
  >
    <div class="flex flex-col gap-4 overflow-y-auto max-h-[80vh]">
      <div class="text-xl text-center font-bold">
        {{ instructions.title }}
      </div>

      <!-- STEP 1: INSTRUCTIONS & USSD -->
      <div v-if="currentStep === 1" class="flex flex-col gap-4 ">
        <div v-if="instructions.ussdCode" class="flex flex-col gap-2 mb-2">
          <div
            class="flex gap-1 items-center border justify-center bg-gray-100 rounded-xl p-4 text-center font-mono text-lg select-all cursor-pointer"
            @click="copyUssdCode"
          >
            {{ instructions.ussdCode }}
          </div>
          
          <div class="flex gap-2">
            <button 
              @click="copyUssdCode"
              class="flex-1 bg-white border border-gray-200 rounded-xl py-2 px-3 text-[10px] font-bold text-gray-600 flex items-center justify-center gap-2 hover:bg-gray-50 transition-colors"
            >
              📋 COPIER
            </button>
            <button 
              @click="$bus.emit($constants.EVENTS.SHARED.LAUNCHED_USSD, { ussdCode: instructions.ussdCode })"
              class="flex-1 bg-primary-600 rounded-xl py-2 px-3 text-[10px] font-bold text-white flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors"
            >
              📞 APPELER
            </button>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <div
            v-for="(instruction, index) in instructions.instructions || []"
            :key="index"
            class="flex flex-col gap-2 text-lg"
          >
            <div
              class="flex justify-between"
              :class="{ 'font-bold underline': instruction.action }"
              @click="onInstructionClicked(instruction)"
              v-if="
                index !== 0 ||
                (instruction.action !== 'copy' && instruction.action !== 'tel')
              "
            >
              <span>
                &bull;
                <span class="" v-html="instruction.text"></span>
              </span>
              <div class="">
                <ColorImg
                  src="/images/formIcons/call.svg"
                  class="w-7 h-7 bg-current"
                  alt=""
                  v-if="instruction.action == 'tel'"
                />
                <ColorImg
                  src="/images/icons/copy.svg"
                  class="w-7 h-7 bg-current"
                  alt=""
                  v-else-if="instruction.action == 'copy'"
                />
              </div>
            </div>

            <div
              v-if="instruction.type === 'double'"
              class="grid grid-cols-2 gap-3"
            >
              <div
                v-if="instruction.option1"
                class="buttonComponent text-center py-3 cursor-pointer"
                @click="onInstructionClicked(instruction.option1)"
              >
                <span v-html="instruction.option1.text"></span>
              </div>
              <div
                v-if="instruction.option2"
                class="buttonComponent text-center py-3 cursor-pointer"
                @click="onInstructionClicked(instruction.option2)"
              >
                <span v-html="instruction.option2.text"></span>
              </div>
            </div>
          </div>
        </div>

        <button
          v-if="instructions.requiredFields?.length"
          class="buttonComponent w-full mt-4"
          @click="currentStep = 2"
        >
          Suivant
        </button>
        <button v-else class="buttonComponent w-full mt-4" @click="submitForm">
          Terminer
        </button>
      </div>

      <!-- STEP 2: REQUIRED FIELDS -->
      <div v-if="currentStep === 2" class="flex flex-col gap-4">
        <div
          v-if="instructions.requiredFields?.length"
          class="flex flex-col gap-3"
        >
          <div
            v-for="field in instructions.requiredFields"
            :key="field.label"
            class="flex flex-col gap-1"
          >
            <label class="text-sm font-medium">{{ field.label }}</label>
            <input
              v-model="formData[field.label]"
              :type="field.type || 'text'"
              :placeholder="field.placeHolder"
              class="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2"
            />
          </div>
        </div>

        <div class="flex flex-col gap-2 mt-4">
          <button class="buttonComponent w-full" @click="submitForm">
            Envoyer
          </button>
          <button
            class="text-gray-500 text-sm font-medium py-2"
            @click="currentStep = 1"
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import Commons from '../../shared/libraries/commons';

const modalRef = ref(null);
const currentStep = ref(1);
const formData = ref({});
const { proxy } = getCurrentInstance();

const instructions = computed(() => {
  return (
    proxy.$stores.services.state.transactionInitiation
      .mobileMoneyOperationConfigs?.manualOperationInstructions || {}
  );
});

const copyUssdCode = () => {
  Commons.copyToClipboard(instructions.value.ussdCode);
};

const onInstructionClicked = (option) => {
  if (!option.action) return;

  if (option.action === 'tel') {
    $bus.emit($constants.EVENTS.SHARED.LAUNCHED_USSD, {
      ussdCode: option.actionContent
    });
  } else if (option.action === 'copy') {
    Commons.copyToClipboard(option.actionContent);
  }
};

const submitForm = () => {
  modalRef.value.hide();
  $bus.emit($constants.EVENTS.SERVICES.INITIATION.MANUAL_INFO_SUBMITTED, {
    manualCollectInfos: formData.value
  });
};
</script>
